let cta_block = document.querySelector('.block-cta');
if(cta_block){

    let ctas = cta_block.querySelectorAll('.featured-excerpt .featured-text');

    document.addEventListener('DOMContentLoaded', (event) => {
        cta_block_equal_heights(ctas);
    })

    window.addEventListener('resize', (event) => {
        cta_block_equal_heights(ctas);
        console.log("resize");
    });

}


function cta_block_equal_heights(collection){
    reset_height_attr(collection);
    let height = cta_block_get_max_height(collection);
    //console.log(height,"max height");
    collection.forEach(item => {
        item.setAttribute("style","height:" + height + "px");
    });
}

function reset_height_attr(collection){
    collection.forEach(item => {
        item.removeAttribute("style");
    });
}

function cta_block_get_max_height(collection){
    max_height = 0;
    collection.forEach(item => {
        if(item.offsetHeight > max_height){
            max_height = item.offsetHeight
        }
    });

    return max_height;
}